module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/ui/analytics-3-97c52cebbf7c3d97796450626ad72f09.png";